import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { SubCategoriesDataService, SubCategoriesColumnsService } from '../../../services';
import { SubCategory, SubCategoriesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-sub-category-details',
  templateUrl: './sub-category-details.component.html',
  styleUrls: ['./sub-category-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SubCategoryDetailsComponent implements OnInit, OnDestroy {

  public subCategory: SubCategory = {};
  public subCategories: SubCategory[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private subCategoriesDataService: SubCategoriesDataService,
    private subCategoriesColumnsService: SubCategoriesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Sub Category - Details');
        this.getSubCategory(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.subCategory !== 'undefined') {
      this.subCategory = this.dynamicDialogConfig.data.subCategory;
    }
    this.columns = this.subCategoriesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getSubCategory(id: number): void {
    this.isLoading = true;
    this.subCategoriesDataService.getSubCategory(id).subscribe((response: SubCategory|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.subCategory = response;
      }
    });
  }

  list() {
    this.router.navigate(['/sub-categories']);
  }

  add() {
    this.router.navigate(['/sub-categories/add']);
  }

  edit() {
    this.router.navigate(['/sub-categories/edit/' + this.subCategory.id]);
  }

}
@Component({
  selector: 'app-sub-category-details',
  templateUrl: './sub-category-details.component.html',
  styleUrls: ['./sub-category-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSubCategoryDetailsComponent extends SubCategoryDetailsComponent {
}

